import { Injectable } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';

// Matches the worker version configured in modal-image.component.ts (pdfjs-dist 3.11.174)
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

@Injectable({
    providedIn: 'root',
})
export class PdfThumbnailService {
    async generateThumbnail(url: string): Promise<string> {
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        const pdfDocument = await pdfjsLib.getDocument({
            data: new Uint8Array(arrayBuffer),
            cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/cmaps/',
            cMapPacked: true,
        }).promise;
        try {
            const page = await pdfDocument.getPage(1);
            const viewport = page.getViewport({ scale: 0.5 });

            const canvas = document.createElement('canvas');
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            const context = canvas.getContext('2d');

            await page.render({ canvasContext: context, viewport }).promise;

            return canvas.toDataURL();
        } finally {
            pdfDocument.destroy();
        }
    }
}
